<template>
    <div class="p-3">
        offers
    </div>
</template>

<script>
export default {
    name: "OfferForms",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
